module.exports = __webpack_public_path__ + "static/bio-a37be496dc7f7833c2c44d94bf4172d3.jpg";